module.exports = __webpack_public_path__ + "img/404.af5859e5.png";